import { Button, Card } from "@rumbledirect/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Input, message, Modal, Radio, Typography } from "antd";
import { useState } from "react";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { useViewConfigurationClient } from "../client";

export interface ReplacementVehicleCardProps {
  title: string;
  description: string;
  emptyState: string;
  submitEndpoint: string;
  submitField: string;
  commentField: string;
  value: boolean;
}

export const ReplacementVehicleCard = ({
  title,
  description,
  emptyState,
  submitEndpoint,
  submitField,
  commentField,
  value,
}: ReplacementVehicleCardProps) => {
  const axiosInstance = useViewConfigurationClient();
  const queryClient = useQueryClient();
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [enabled, setEnabled] = useState(value);
  const [comment, setComment] = useState("");

  const openModal = () => {
    setEnabled(value);
    setComment("");
    setOptionsVisible(true);
  };

  const submitMutation = useMutation({
    mutationFn: async () =>
      axiosInstance.patch(
        submitEndpoint,
        {
          [submitField]: enabled,
          [commentField]: enabled && comment.trim() ? comment.trim() : null,
        },
        { headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON } },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["view-configuration"] });
      setOptionsVisible(false);
    },
    onError: () => {
      message.error("Er is een fout opgetreden. Probeer het opnieuw.");
    },
  });

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{title}</span>
          <Button
            type="link"
            style={{ padding: 0, fontWeight: "normal" }}
            onClick={openModal}
          >
            wijzigen
          </Button>
        </div>
      }
    >
      <Typography.Paragraph type="secondary" style={{ margin: 0 }}>
        {value ? "Er is vervangend vervoer geselecteerd" : emptyState}
      </Typography.Paragraph>

      <Modal
        title={`${title} wijzigen`}
        open={optionsVisible}
        onCancel={() => setOptionsVisible(false)}
        onOk={() => submitMutation.mutate()}
        okText="Opslaan"
        okButtonProps={{ loading: submitMutation.isPending }}
      >
        <Typography.Paragraph type="secondary">
          {description}
        </Typography.Paragraph>
        <Radio.Group
          value={enabled}
          onChange={(event) => setEnabled(event.target.value)}
          style={{ marginBottom: 16 }}
        >
          <Radio value={true}>Ja</Radio>
          <Radio value={false}>Nee</Radio>
        </Radio.Group>

        {enabled && (
          <Input.TextArea
            placeholder="Opmerkingen (optioneel)"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            rows={3}
          />
        )}
      </Modal>
    </Card>
  );
};
